import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-admin-options',
    templateUrl: './admin-options.component.html',
    styleUrls: ['./admin-options.component.scss'],
})
export class AdminOptionsComponent implements OnInit {

    public show: string = '';

    constructor() {
    }

    ngOnInit() {
    }

}
